import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, Sparkles } from 'lucide-react';

const CognitiveAnalysis = ({ cognitiveStats, isDemo = false }) => {
  if (!cognitiveStats?.has_data) return null;

  return (
    <Card className={`bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 mb-6 ${isDemo ? 'relative overflow-hidden' : ''}`} data-testid="cognitive-stats-card">
      {isDemo && (
        <div className="absolute top-2 right-2 z-10">
          <Badge variant="outline" className="text-xs bg-amber-50 text-amber-700 border-amber-300">
            Sample Data
          </Badge>
        </div>
      )}
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
            <TrendingUp className="w-4 h-4 text-white" />
          </div>
          Cognitive Analysis
          <Badge variant="secondary" className="text-xs font-normal">Bloom</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Recall */}
          <div className="space-y-1">
            <div className="flex justify-between items-center">
              <Badge className="bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300 text-xs">Recall</Badge>
              <span className="text-sm font-medium">{cognitiveStats.cognitive_stats?.recall?.percentage || 0}%</span>
            </div>
            <div className="h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500" style={{ width: `${cognitiveStats.cognitive_stats?.recall?.percentage || 0}%` }} />
            </div>
          </div>
          
          {/* Apply */}
          <div className="space-y-1">
            <div className="flex justify-between items-center">
              <Badge className="bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300 text-xs">Apply</Badge>
              <span className="text-sm font-medium">{cognitiveStats.cognitive_stats?.apply?.percentage || 0}%</span>
            </div>
            <div className="h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
              <div className="h-full bg-purple-500" style={{ width: `${cognitiveStats.cognitive_stats?.apply?.percentage || 0}%` }} />
            </div>
          </div>
          
          {/* Analyze */}
          <div className="space-y-1">
            <div className="flex justify-between items-center">
              <Badge className="bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300 text-xs">Analyze</Badge>
              <span className="text-sm font-medium">{cognitiveStats.cognitive_stats?.analyze?.percentage || 0}%</span>
            </div>
            <div className="h-2 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
              <div className="h-full bg-orange-500" style={{ width: `${cognitiveStats.cognitive_stats?.analyze?.percentage || 0}%` }} />
            </div>
          </div>
        </div>
        
        {cognitiveStats.recommendation && (
          <p className="text-xs text-slate-500 mt-3 flex items-center gap-1">
            <Sparkles className="w-3 h-3 text-amber-500" />
            {cognitiveStats.recommendation}
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default CognitiveAnalysis;
